const scrollToFAQTopic = (topicId: string, onLinkClick: () => void) => {
  document.getElementById(topicId)?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });

  onLinkClick();
};

export { scrollToFAQTopic };
